<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" append-to-body>
        <!-- 详细信息 -->
        <el-tabs v-model="Dactive" type="card" v-if="!coordinator">
            <el-tab-pane :label="$t('integration.detailed_information')" name="Detail"></el-tab-pane>
            <!--<el-tab-pane v-if="detailObj.type === 3" :label="$t('integration.gateway_coordinator')"-->
            <!--    name="Coordinator"></el-tab-pane>-->
        </el-tabs>
        <!-- <Tabs :tabs="detailTbs" :activeCom.sync="Dactive" /> -->
        <template v-if="Dactive === 'Detail'">
            <div class="detailClass">
                <BaseList @saveDecFn="confrimFn" :baseMsgArray="baseMsgArray" :detailObj="detailObj" :isMode.sync="isMode"
                    :coordinator="coordinator" :deviceAssociate='deviceAssociate'   :locationList="locationList"  :groupList="groupList" />
                <Upload :Upload="Upload" :isMode="isMode" ref="upload" v-if="!coordinator" />
            </div>
        </template>

        <template v-else>
            <Coordinator :list="completeInfo.coordinatorList"></Coordinator>
        </template>

        <el-tabs v-model="tabsActive" type="card">
            <el-tab-pane :label="$t('integration.attribute')" name="Application"></el-tab-pane>
            <el-tab-pane :label="$t('integration.network_parameters')" name="NetParam"
                v-if="detailObj.type <= 2"></el-tab-pane>
            <el-tab-pane :label="$t('integration.alarm_parameters')" name="AlarmParam" v-else></el-tab-pane>
        </el-tabs>
        <keep-alive>
            <component :is="tabsActive" v-bind="$attrs" :detailNetObj="netArray" :completeInfo="completeInfo" />
        </keep-alive>
        <div slot="footer">
            <!-- AT指令只有绑定和未绑定时展示-->
            <!--<el-button v-if="way === ENUM_DEVICE_WAY.BIND || way === ENUM_DEVICE_WAY.UNBIND"  type='primary' @click='toAtCommandPage'>{{$t('integration.at_instruction')}}</el-button>-->
            <el-button type="primary" v-if="detailObj.isHeart === 1" @click="hearFn">{{ $t('device.heartbeat_history') }}
            </el-button>
            <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Close') }}</el-button>
        </div>
        <!-- 心跳弹窗 -->
        <HearDialog :append-to-body="true" :totalAll="totalAll" :title="hearTitle" :isShow.sync="isShow"
            :tableData="tableData" :mac="hearQuery.mac" :loading.sync="loading" />
    </modal>
</template>
<script>
import Tabs from '@/pages/equipment/publicCom/Tabs.vue'
import NetParam from '@/pages/equipment/publicCom/NetParam.vue'
import Application from '@/pages/equipment/publicCom/Application.vue'
import Upload from '@/pages/equipment/publicCom/Upload.vue'
import BaseList from './component/BaseList.vue'
import HearDialog from './component/hearDialog.vue'
import bus from '@/utils/bus'
import { gatewayhistoryList, gatewayUpdate } from '@/api/modules/gateway.js'
import AlarmParam from '@/components/dialog/gatewayDetail/component/component/gateway02/AlarmParam'
import { RuleExtPanId, RuleChannelPage, RuleChannelMask } from '@/utils/rules'
import resultHandle from '@/common/resultHandle'
import Coordinator from './component/gateway02/Coordinator.vue'
import { atCommand } from '@/utils/winDetail'
import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'
import { getLocationList, getGroupList } from '@/api/modules/public.js'
export default {
  props: ['title', 'isDetailShow', 'netObj', 'way', 'detailObj','deviceAssociate', 'completeInfo', 'coordinator'],
  components: {
    Tabs,
    Upload,
    BaseList,
    // changeIcon,
    NetParam,
    Application,
    HearDialog,
    Coordinator,
    AlarmParam
  },
  computed: {
    ENUM_DEVICE_WAY () {
      return ENUM_DEVICE_WAY
    },
    isShowDialog: {
      get: function () {
        return this.isDetailShow
      },
      set: function (val) {
        this.$emit('update:isDetailShow', val) // 可以优化成model  或者minx
      }
    }
  },
  watch: {
    netObj (newVal) {
      this.netArray.forEach(item => {
        item.content = newVal[item.key]
      })
      this.isMode = false
    },
    detailObj (newVal) {
      this.isMode = false
      this.Upload = {
        imageUrl: { ...newVal }.pictureBase64,
        // 图片后缀
        imageSuffix: { ...newVal }.pictureSuffix
      }
      this.Dactive = 'Detail'
      this.tabsActive = 'Application'
      this.getLocation(this.detailObj.id);
      this.getGroup(this.detailObj.id);
    }
  },
  data () {
    return {
      Dactive: 'Detail',

      tabsActive: 'Application',
      loading: false,
      baseMsgArray: [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'name',
          text: $t('integration.gateway_name_')
        },
        {
          key: 'carrierName',
          text: $t('integration.mount_')
        },
        {
          key: 'mac',
          text: 'device.gateway_mac'
        },
        {
          key: 'sn',
          text: 'device.gateway_serial_num'
        },
        {
          key: 'code',
          text: 'device.gateway_type'
        },
        {
          key: 'status',
          text: 'device.gateway_status'
        },
        {
          key: 'edited',
          text: 'device.activated'
        },
        {
          key: 'configStatus',
          text: 'device.config_status'
        },
        {
          key: 'createTime',
          text: 'public.table_create_time'
        },
        {
          key: 'powerStatus',
          text: $t('integration.battery_supply')
        },
        {
          key: 'isHeart',
          text: 'device.heartbeat_on'
        },
        {
          key: 'ip',
          text: 'ip'
        },
        {
          key: 'selfIp',
          text: $t('integration.private_ip')
        },
        {
          key: 'location',
          text: $t('public.location_desc'),
        },
        {
          key: 'group',
          text: $t('public.group_desc'),
        },
        {
          key: 'nickname',
          text: $t('integration.gateway_nickname')
        },
        {
          key: 'description',
          text: $t('public.table_desc')
        }
      ],
      netArray: [
        {
          key: 'extPanId',
          text: 'extPanId',
          content: '',
          rules: RuleExtPanId
        },
        {
          key: 'channelPage',
          text: 'channelPage',
          content: '',
          rules: RuleChannelPage
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          content: '',
          rules: RuleChannelMask
        }
      ],
      isMode: false,
      // 图片
      Upload: {},
      // 心跳
      hearTitle: '',
      isShow: false,
      hearQuery: {
        iDisplayStart: 0,
        iDisplayLength: 15,
        mac: null,
        startTime: null,
        endTime: null
      },
      tableData: [],
      totalAll: 0,
      locationList: [], //  位置列表
      groupList: [], // 群组列表
    }
  },
  mounted () {
    if (this.$attrs.sensorWay === 'unknown') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName' && item.key !== 'config_status')
    }
    if (this.$attrs.sensorWay === 'unbind') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'carrierName')
    }
    if (this.$attrs.sensorWay === 'stop') {
      this.baseMsgArray = this.baseMsgArray.filter(item => item.key !== 'config_status')
    }
  },
  methods: {
    // 前往at指令
    toAtCommandPage () {
      atCommand(this.detailObj)
    },
    confrimFn (row) {
      const { imageSuffix, imageUrl } = this.$refs.upload.newUpload
      const { id, is_heart, nickname, areaValue,locationId,groupId } = row
      gatewayUpdate({
        id,
        is_heart,
        nickname,
        locationId: locationId,
        groupId: groupId,
        description: areaValue,
        uploadFileBase64: imageUrl,
        uploadFileSuffix: imageSuffix
      }).then(async ({ state }) => {
        await resultHandle(state)
        this.isMode = !this.isMode
        bus.$emit('gatewayParam', this.detailObj.id, this.detailObj.name)
        // this.$emit('changdetail', this.detailObj);
        // this.$parent.getListFn()
      })
    },
    hearFn () {
      this.isShow = true
      this.hearTitle = `[${this.detailObj.name}]` + $t('integration.gateway_heartbeat_history')
      this.hearQuery.mac = this.detailObj.mac
      this.loading = true
      gatewayhistoryList(this.hearQuery).then(({ result }) => {
        this.tableData = result.result
        this.totalAll = result.pageInfo.total
      }).finally(() => this.loading = false)
    },
    getLocation( id){
      getLocationList({deviceCatalog:1,deviceId:id}).then(res => {
        if (res.state.code === 200) {
          this.locationList = res.result
        }
      })
    },
    getGroup(id ){
      getGroupList({deviceCatalog:1,deviceId:id}).then(res => {
        if (res.state.code === 200) {
          this.groupList = res.result
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    min-width: 900px;
}

.detailClass {
    display: flex;
}
</style>
